import { z } from "zod";

import type { BooleanArrayCondition } from "./arrays/booleans.ts";
import { BooleanArrayBinaryCondition, BooleanArrayTernaryCondition } from "./arrays/booleans.ts";
import type { NumberArrayCondition } from "./arrays/numbers.ts";
import { NumberArrayBinaryCondition, NumberArrayTernaryCondition } from "./arrays/numbers.ts";
import type { ObjectArrayCondition } from "./arrays/objects.ts";
import { ObjectArrayBinaryCondition, ObjectArrayTernaryCondition } from "./arrays/objects.ts";
import type { StringArrayCondition } from "./arrays/strings.ts";
import { StringArrayBinaryCondition, StringArrayTernaryCondition } from "./arrays/strings.ts";
import type { BooleanCondition } from "./boolean.ts";
import { BooleanBinaryCondition } from "./boolean.ts";
import type { NumberCondition } from "./number.ts";
import { NumberBinaryCondition, NumberTernaryCondition } from "./number.ts";
import type { StringCondition } from "./string.ts";
import { StringBinaryCondition } from "./string.ts";

// Unified Condition schema using discriminated union on "type" field
export const Condition: z.ZodType<Condition> = z.lazy(() =>
  z.discriminatedUnion("type", [
    // Number conditions
    NumberBinaryCondition,
    NumberTernaryCondition,
    // String conditions
    StringBinaryCondition,
    // Boolean conditions
    BooleanBinaryCondition,
    // Number array conditions
    NumberArrayBinaryCondition,
    NumberArrayTernaryCondition,
    // String array conditions
    StringArrayBinaryCondition,
    StringArrayTernaryCondition,
    // Boolean array conditions
    BooleanArrayBinaryCondition,
    BooleanArrayTernaryCondition,
    // Object array conditions
    ObjectArrayBinaryCondition,
    ObjectArrayTernaryCondition,
  ]),
);
export type Condition =
  | NumberCondition
  | StringCondition
  | BooleanCondition
  | NumberArrayCondition
  | StringArrayCondition
  | BooleanArrayCondition
  | ObjectArrayCondition;

// Re-exports
export {
  BooleanArrayBinaryCondition,
  BooleanArrayCondition,
  BooleanArrayTernaryCondition,
  type IBooleanArrayBinaryCondition,
  type IBooleanArrayTernaryCondition,
} from "./arrays/booleans.ts";
export {
  NumberArrayBinaryCondition,
  NumberArrayCondition,
  NumberArrayTernaryCondition,
  type INumberArrayBinaryCondition,
  type INumberArrayTernaryCondition,
} from "./arrays/numbers.ts";
export {
  ObjectArrayBinaryCondition,
  ObjectArrayCondition,
  ObjectArrayTernaryCondition,
  type IObjectArrayBinaryCondition,
  type IObjectArrayTernaryCondition,
} from "./arrays/objects.ts";
export {
  StringArrayBinaryCondition,
  StringArrayCondition,
  StringArrayTernaryCondition,
  type IStringArrayBinaryCondition,
  type IStringArrayTernaryCondition,
} from "./arrays/strings.ts";
export { BooleanBinaryCondition, BooleanCondition, type IBooleanBinaryCondition } from "./boolean.ts";
export { ConditionType } from "./common.ts";
export {
  NumberBinaryCondition,
  NumberCondition,
  NumberTernaryCondition,
  type INumberBinaryCondition,
  type INumberTernaryCondition,
} from "./number.ts";
export { StringBinaryCondition, StringCondition, type IStringBinaryCondition } from "./string.ts";
